import React from "react";
import styled from "styled-components";
import { VideoSection } from "@domain/lms/article/article";
import { DetailedArticle } from "@domain/lms/article/dtos";
import { getAssetById } from "@domain/lms/article/utils";
import { TooshareVideoPlayer } from "@ui/components/media/tooshareVideoPlayer";
import { VideoPlayer } from "@ui/components/media/videoPlayer";

interface VideoSectionViewProps extends React.HTMLAttributes<HTMLDivElement> {
	section: VideoSection;
	article: DetailedArticle;
}
export const VideoSectionView: React.FC<VideoSectionViewProps> = ({ section, article, ...htmlProps }) => {
	const asset = "assetId" in section && getAssetById(article.content, section.assetId);

	return (
		<Container {...htmlProps}>
			{"url" in section && section.url != null ? (
				<VideoPlayer source={section.url} />
			) : asset ? (
				<TooshareVideoPlayer asset={asset} />
			) : null}
		</Container>
	);
};

const Container = styled.div`
	width: 100%;
	border-radius: 12px;
	overflow: hidden;
`;
